import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
} from 'recharts';
import { withTranslation } from 'react-i18next';

class ProductSales extends PureComponent {
   static propTypes = {
      // data: PropTypes.objectOf(),
      // data: PropTypes.objectOf(PropTypes.checkPropTypes()),
      data: PropTypes.arrayOf(PropTypes.object),
   };

   static defaultProps = {
      data: [
         {
            name: 'Week 1', current: 0,
         },
         {
            name: 'Week 2', current: 0,
         },
         {
            name: 'Week 3', current: 0,
         },
         {
            name: 'Week 4', current: 0,
         },
      ],
   };

   render() {
      const { data } = this.props;

      return (
         <ResponsiveContainer height={280} className="dashboard__area">
            <AreaChart data={data} margin={{ left: -30 }}>
               <XAxis dataKey="name" tickLine={false} />
               <YAxis tickLine={false} />
               <Tooltip />
               <Legend />
               <CartesianGrid />
               <Area
                  name="Sales"
                  type="monotone"
                  dataKey="current"
                  fill="#4ce1b6"
                  stroke="#4ce1b6"
                  fillOpacity={0.2}
               />
               {/* <Area name="Plan Sales" type="monotone" dataKey="plan" fill="#70bbfd" stroke="#70bbfd" fillOpacity={0.2} /> */}
            </AreaChart>
         </ResponsiveContainer>
      );
   }
}

export default withTranslation('common')(ProductSales);
